import { BaseUrlService } from './base-url.service';

export class GoogleDriveService {
    static $inject: string[] = ['$http', 'BaseUrlService', '$rootScope'];

    private baseUrl: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService,
        private $rootScope: any
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    uploadFiles(files: any) {
        return this.$http.post(this.baseUrl + '/google-drive/upload-files', files);
    }

    authorize(code: any) {
        return this.$http.put(this.baseUrl + '/google-drive/authorize/' + encodeURIComponent(this.$rootScope.domain), code);
    }

    getAuthorizationUrl() {
        return this.$http.get(this.baseUrl + '/google-drive/authorization-url/' + encodeURIComponent(this.$rootScope.domain));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/google-drive.service.ts